/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Offset_TypeInputs */

const en_dialogue_list_export_offset_type = /** @type {(inputs: Dialogue_List_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset Type`)
};

const fr_dialogue_list_export_offset_type = /** @type {(inputs: Dialogue_List_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de décalage`)
};

const de_dialogue_list_export_offset_type = /** @type {(inputs: Dialogue_List_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset-Typ`)
};

const it_dialogue_list_export_offset_type = /** @type {(inputs: Dialogue_List_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di offset`)
};

const ru_dialogue_list_export_offset_type = /** @type {(inputs: Dialogue_List_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип смещения`)
};

const es_dialogue_list_export_offset_type = /** @type {(inputs: Dialogue_List_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de desplazamiento`)
};

const zh_cn2_dialogue_list_export_offset_type = /** @type {(inputs: Dialogue_List_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`偏移类型`)
};

const ja_dialogue_list_export_offset_type = /** @type {(inputs: Dialogue_List_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフセットタイプ`)
};

const hi_dialogue_list_export_offset_type = /** @type {(inputs: Dialogue_List_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफसेट प्रकार`)
};

const pt_pt2_dialogue_list_export_offset_type = /** @type {(inputs: Dialogue_List_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de deslocamento`)
};

/**
* | output |
* | --- |
* | "Offset Type" |
*
* @param {Dialogue_List_Export_Offset_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_offset_type = /** @type {((inputs?: Dialogue_List_Export_Offset_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Offset_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_offset_type(inputs)
	if (locale === "de") return de_dialogue_list_export_offset_type(inputs)
	if (locale === "it") return it_dialogue_list_export_offset_type(inputs)
	if (locale === "ru") return ru_dialogue_list_export_offset_type(inputs)
	if (locale === "es") return es_dialogue_list_export_offset_type(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_offset_type(inputs)
	if (locale === "ja") return ja_dialogue_list_export_offset_type(inputs)
	if (locale === "hi") return hi_dialogue_list_export_offset_type(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_offset_type(inputs)
	return en_dialogue_list_export_offset_type(inputs)
});